/*
 * Copyright (c) 2018. keni <$email>
 *
 * This file SocketCommandJavascript.js is part of event_pass_client.dev.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential
 * SocketCommandJavascript.js can not be copied and/or distributed
 * without the express permission of keni
 */

/**
 * Created by matos on 05/06/2017.
 */
export function SocketCommandJavascript(options = {}) {
	// console.log('window.Echo',window.Echo);
	let socketCommandPlugin = {
		init:function (options){
			//Setting the chat event listener
			window.ClientEcho.channel(options.channel)
				.listen('.' + options.event, (e) => {
					eval(e.command);
				});
		}
	};

	socketCommandPlugin.init(options);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/notifications/SocketCommandJavascript.js